import React, { useEffect, useState } from "react";
import ModalComponent from "../../../components/modals";
import { useForm } from "react-hook-form";
import "./styles.css";
import SimpleTable from "../../../components/tables/simpleTable";
import { useLoadingState } from "../../../components/loadingFeedback";
import {
  callApiAsync,
  getServiceOrderNotification
} from "../../../services/apiService";
import { notificationStatus } from "../../../constants/enums";
import { hasAnyRoleUtil } from "../../../services/roleService";
import { useSelector } from "react-redux";
import { BIOMEDICAL_SERVICE_ORDER_EDIT_ROLES } from "../../../constants/biomedicalRoles";

const NotificationsModal = ({ open, close, userId }) => {
  const [notification, setNotification] = useState([]);
  const [loadingNotifications, setLoadingNotifications] = useLoadingState();

  const { control, watch, setValue } = useForm();

  const userData = useSelector((state) => state.userData.userData);

  const isServiceOrderManagment = hasAnyRoleUtil(
    BIOMEDICAL_SERVICE_ORDER_EDIT_ROLES,
    userData.roleList
  );

  const getStatusName = (status) => {
    switch (status) {
      case notificationStatus.lapsed:
        return "VENCIDO";
      case notificationStatus.completed:
        return "PRÓXIMO A VENCER";
      default:
        return "-";
    }
  };

  const tableColumns = [
    { field: "serviceOrderName", header: "OS", columnWidth: "300px" },
    { field: "orderActivity", header: "Actividad", columnWidth: "350px" },
    {
      field: "minutesLeft",
      header: "Tiempo faltante",
      columnWidth: "190px",
      columnType: "custom",
      render: (rowData) => {
        return (
          <p className="table-default-column w-max-content text-cente">
            {rowData.minutesLeft}
          </p>
        );
      }
    },
    { field: "orderActivityState", header: "Estado", columnWidth: "400px" }
  ];

  const getNotifications = async (user_id) => {
    const dataToSend = isServiceOrderManagment ? 0 : user_id;
    callApiAsync(
      () => getServiceOrderNotification(dataToSend),
      (data) => {
        setNotification(data);
      },
      setLoadingNotifications
    );
  };

  useEffect(() => {
    if (open) {
      getNotifications(userId);
    }
  }, [open]);

  const handleClose = () => {
    close();
  };

  return (
    <ModalComponent
      open={open}
      handleClose={handleClose}
      title={"Notificaciones"}
      width="600px"
      actions={<></>}
    >
      <SimpleTable
        loading={loadingNotifications}
        data={notification}
        columns={tableColumns}
        scrollHeight={"300px"}
        text={"Realizar Autoevaluación"}
        buttons={[{ type: "button" }]}
      />
    </ModalComponent>
  );
};

export default NotificationsModal;
